import { useTranslation } from 'react-i18next'

import { CopyButton } from '@root/shared/ui-kit'

import type { CurrencyModel } from '@root/entities/currency'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  currency: CurrencyModel
  size?: number
  fullWidth?: boolean
} & ClassNameProps

export const CurrencyInformationClipboard: React.FC<Props> = ({
  currency,
  fullWidth,
  size = 16,
  className,
}) => {
  const { t } = useTranslation()

  return (
    <CopyButton
      className={className}
      fullWidth={fullWidth}
      size={size}
      value={currency.address}
      tooltip={t('currency.token_address_copy_tooltip')}
      snackbarText={t('currency.token_address_copied_message', {
        ticker: currency.ticker,
      })}
    />
  )
}
